import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './router';
import { useSelector } from 'react-redux';
import SessionExpiredModal from '../components/SessionExpiredModal'
import { selectSessionExpired,selectIsLoggedIn} from '../store/slices/authSlice';
import { Toaster } from 'react-hot-toast';


const App = () => {
  const sessionExpired = useSelector(selectSessionExpired);
  const isLoggedIn=useSelector(selectIsLoggedIn);

  return (
    
    <BrowserRouter>
      {sessionExpired && isLoggedIn &&<SessionExpiredModal />}
       <Toaster position="top-center" />
      <Router/>
      
    </BrowserRouter>
  );
};

export default App;